import React from 'react'
import cn from 'classnames'
import { Button, IconPlayDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import style from '../../CampPageScreen.module.scss'

interface TrailerButtonProps {
  onClick: () => void
  className?: string
}

export const TrailerButton = ({
  onClick,
  className = '',
}: TrailerButtonProps) => {
  const { t } = useTranslation('@mc/next')

  return (
    <Button
      onClick={onClick}
      kind='play'
      size='sm'
      className={cn(style.watchTrailerButton, className)}
    >
      <IconPlayDefault className='mc-mr-2' srText='' />
      <div className='d-block d-md-none'>
        {t('sessions.campHeroCTAs.trailerMobile')}
      </div>
      <div className='d-none d-md-block'>
        {t('sessions.campHeroCTAs.trailerDesktop')}
      </div>
    </Button>
  )
}
